import styled from "styled-components";

export const ModelVersionBadge = styled.span`
  background-color: var(--spectrum-gray-200);
  color: var(--spectrum-gray-800);
  border-radius: 8px;
  font-weight: bold;
  font-size: 16px;
  padding: 0 6px;
`;

export const ModelVersionBadgeListItem = styled(ModelVersionBadge)<{
  selected: boolean;
}>`
  border-radius: 7px;
  font-size: 13px;

  ${({ selected }): string =>
    selected
      ? `
    background-color: var(--spectrum-global-color-static-indigo-700);
    color: white;
  `
      : ""}
`;
